import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserStore } from '../stores/user.store';
import { AuthService } from '../services/auth.service';

export const loggedInGuard: CanActivateFn = async (route, state) => {
  const userStore = inject(UserStore);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (userStore.isLoggedIn()) {
    return true;
  }

  await authService.getMe().subscribe({
    next: () => {
      window.location.reload();
      return true;
    },
    error: () => {
      router.navigate(['/auth/sign-in']);
    },
  });

  return false;
};
